<div class="NgxEditor__Wrapper" [ngClass]="isText?isExpand?'text expand':'text':''"
    [ngClass]="{'isDisplay': isDisplay, 'isEmpty':isEmpty}">
    <ngx-editor-menu *ngIf="!isDisplay" [editor]="editor"> </ngx-editor-menu>
    <ngx-editor class="editor" [editor]="editor" [formControl]="html" [disabled]="false"
        [placeholder]="placeholder"></ngx-editor>
</div>